import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";

export class IrregularidadeOperacaoGarantida extends BaseEntity  {
    id:number;
    idAgenteFinanceiro:number;
    idOperacaoExterno: string;
    sistemaRepasse:string;
    contratoRepasse:string; 
    motivo:string;
    dataEnvio: string;
    dataInicio:string;
    dataFim:string;
    nomeUsuarioEnvio: string;
    nomeUsuarioUltimaAtualizacao: string;
    mensagem:string;
}


export const TIPO_CLASSE_OPERACAO =[
    {
        codigo: 'CL',
        nome:"CL - Credito Livre"
    },
    {
        codigo: '15',
        nome:"15 - FINAME",
    },
    {
        codigo: '89',
        nome:"89 - BNDES"
    },

]
